import { useEffect, useState } from 'react';
import { detectEnv } from '../../utils/helper';

export enum Env {
  BROWSER = 'browser',
  WEBVIEW = 'webview',
}

export const useEnv = (): Env | null => {
  const [env, setEnv] = useState<Env | null>(null);
  useEffect(() => {
    const ua = typeof window !== 'undefined' ? navigator.userAgent : '';
    setEnv(detectEnv(ua) as Env);
  }, []);
  return env;
};
